/**
 * Fisher-Yates 洗牌算法（均匀随机）
 * 替代有偏的 sort(() => Math.random() - 0.5)
 */
export function shuffle<T>(array: T[]): T[] {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
